import { createVNode as _createVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, toDisplayString as _toDisplayString, resolveDirective as _resolveDirective, withDirectives as _withDirectives, openBlock as _openBlock, createBlock as _createBlock, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-5daf5f6c")

_pushScopeId("data-v-5daf5f6c")
const _hoisted_1 = { class: "visit-record" }
const _hoisted_2 = /*#__PURE__*/_createVNode("h5", null, [
  /*#__PURE__*/_createVNode("i", { class: "el-icon-document" }),
  /*#__PURE__*/_createTextVNode(" 平台访问记录 ")
], -1)
const _hoisted_3 = { class: "SearchPaging" }
const _hoisted_4 = /*#__PURE__*/_createTextVNode("搜索")
const _hoisted_5 = /*#__PURE__*/_createTextVNode("清空")
const _hoisted_6 = { class: "Statistics visit-record" }
const _hoisted_7 = /*#__PURE__*/_createVNode("h5", null, [
  /*#__PURE__*/_createVNode("i", { class: "el-icon-edit-outline" }),
  /*#__PURE__*/_createTextVNode(" 各项目报告统计 ")
], -1)
const _hoisted_8 = { class: "SearchPaging" }
const _hoisted_9 = /*#__PURE__*/_createTextVNode("搜索")
const _hoisted_10 = /*#__PURE__*/_createTextVNode("清空")
const _hoisted_11 = { class: "trend visit-record" }
const _hoisted_12 = /*#__PURE__*/_createVNode("h5", null, [
  /*#__PURE__*/_createVNode("i", { class: "el-icon-data-line" }),
  /*#__PURE__*/_createTextVNode(" 访问量趋势 ")
], -1)
const _hoisted_13 = /*#__PURE__*/_createTextVNode("查询")
const _hoisted_14 = /*#__PURE__*/_createTextVNode("最近一周")
const _hoisted_15 = {
  id: "trend_chart",
  style: {"width":"100%","height":"300px"}
}
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_el_divider = _resolveComponent("el-divider")
  const _component_el_input = _resolveComponent("el-input")
  const _component_el_form_item = _resolveComponent("el-form-item")
  const _component_el_form = _resolveComponent("el-form")
  const _component_el_button = _resolveComponent("el-button")
  const _component_el_table_column = _resolveComponent("el-table-column")
  const _component_el_link = _resolveComponent("el-link")
  const _component_el_table = _resolveComponent("el-table")
  const _component_el_pagination = _resolveComponent("el-pagination")
  const _component_el_card = _resolveComponent("el-card")
  const _component_el_date_picker = _resolveComponent("el-date-picker")
  const _component_el_main = _resolveComponent("el-main")
  const _component_el_container = _resolveComponent("el-container")
  const _directive_loading = _resolveDirective("loading")

  return (_openBlock(), _createBlock(_component_el_container, null, {
    default: _withId(() => [
      _createVNode(_component_el_container, null, {
        default: _withId(() => [
          _createVNode(_component_el_main, null, {
            default: _withId(() => [
              _createVNode(_component_el_card, { style: {"width":"1200px","margin":"0 auto"} }, {
                default: _withId(() => [
                  _createVNode("div", _hoisted_1, [
                    _hoisted_2,
                    _createVNode(_component_el_divider),
                    _createVNode(_component_el_card, { class: "spacName" }, {
                      default: _withId(() => [
                        _createVNode("div", _hoisted_3, [
                          _createVNode(_component_el_form, { inline: true }, {
                            default: _withId(() => [
                              _createVNode(_component_el_form_item, { label: "每页" }, {
                                default: _withId(() => [
                                  _createVNode(_component_el_input, {
                                    modelValue: _ctx.record,
                                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.record = $event)),
                                    size: "mini",
                                    style: {"width":"50px"},
                                    onChange: _cache[2] || (_cache[2] = ($event: any) => (_ctx.showList('record_input')))
                                  }, null, 8, ["modelValue"])
                                ]),
                                _: 1
                              }),
                              _createVNode(_component_el_form_item, { label: "条记录" })
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_el_form, { inline: true }, {
                            default: _withId(() => [
                              _createVNode(_component_el_form_item, null, {
                                default: _withId(() => [
                                  _createVNode(_component_el_input, {
                                    modelValue: _ctx.record_input,
                                    "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (_ctx.record_input = $event)),
                                    placeholder: "搜索",
                                    "prefix-icon": "el-icon-search",
                                    size: "mini"
                                  }, null, 8, ["modelValue"])
                                ]),
                                _: 1
                              }),
                              _createVNode(_component_el_form_item, null, {
                                default: _withId(() => [
                                  _createVNode(_component_el_button, {
                                    type: "primary",
                                    size: "mini",
                                    onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.recordSearch('record_input')))
                                  }, {
                                    default: _withId(() => [
                                      _hoisted_4
                                    ]),
                                    _: 1
                                  })
                                ]),
                                _: 1
                              }),
                              _createVNode(_component_el_form_item, null, {
                                default: _withId(() => [
                                  _createVNode(_component_el_button, {
                                    type: "primary",
                                    size: "mini",
                                    onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.clearSearch('record_input')))
                                  }, {
                                    default: _withId(() => [
                                      _hoisted_5
                                    ]),
                                    _: 1
                                  })
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          })
                        ]),
                        _withDirectives(_createVNode(_component_el_table, {
                          data: _ctx.getVisitStatistics.results,
                          "header-cell-class-name": "tabelHeader"
                        }, {
                          default: _withId(() => [
                            _createVNode(_component_el_table_column, {
                              index: _ctx.indexMethod(0, 'record_input'),
                              type: "index",
                              label: "序号",
                              width: "80"
                            }, null, 8, ["index"]),
                            _createVNode(_component_el_table_column, {
                              prop: "user_name",
                              label: "访问者",
                              width: "120",
                              sortable: ""
                            }),
                            _createVNode(_component_el_table_column, {
                              prop: "dept",
                              label: "部门",
                              "min-width": "200",
                              sortable: ""
                            }),
                            _createVNode(_component_el_table_column, {
                              prop: "module",
                              label: "访问页面"
                            }, {
                              default: _withId((scope) => [
                                _createVNode(_component_el_link, {
                                  type: "primary",
                                  target: "_blank",
                                  href: scope.row?.page_url
                                }, {
                                  default: _withId(() => [
                                    _createTextVNode(_toDisplayString(scope.row?.module), 1)
                                  ]),
                                  _: 2
                                }, 1032, ["href"])
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_el_table_column, {
                              prop: "visit_time",
                              width: "180",
                              label: "最近访问时间",
                              sortable: ""
                            })
                          ]),
                          _: 1
                        }, 8, ["data"]), [
                          [_directive_loading, _ctx.loading]
                        ]),
                        _createVNode(_component_el_pagination, {
                          currentPage: _ctx.currentPage1,
                          "onUpdate:currentPage": _cache[6] || (_cache[6] = ($event: any) => (_ctx.currentPage1 = $event)),
                          "page-size": _ctx.record,
                          layout: "total, prev, pager, next,jumper",
                          total: _ctx.getVisitStatistics.count,
                          onCurrentChange: _cache[7] || (_cache[7] = ($event: any) => (_ctx.handleCurrentChange('record_input')))
                        }, null, 8, ["currentPage", "page-size", "total"])
                      ]),
                      _: 1
                    })
                  ]),
                  _createVNode("div", _hoisted_6, [
                    _hoisted_7,
                    _createVNode(_component_el_divider),
                    _createVNode(_component_el_card, { class: "spacName" }, {
                      default: _withId(() => [
                        _createVNode("div", _hoisted_8, [
                          _createVNode(_component_el_form, { inline: true }, {
                            default: _withId(() => [
                              _createVNode(_component_el_form_item, { label: "每页" }, {
                                default: _withId(() => [
                                  _createVNode(_component_el_input, {
                                    modelValue: _ctx.statistics,
                                    "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => (_ctx.statistics = $event)),
                                    size: "mini",
                                    style: {"width":"50px"},
                                    onChange: _cache[9] || (_cache[9] = ($event: any) => (_ctx.showList('statistics_input')))
                                  }, null, 8, ["modelValue"])
                                ]),
                                _: 1
                              }),
                              _createVNode(_component_el_form_item, { label: "条记录" })
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_el_form, { inline: true }, {
                            default: _withId(() => [
                              _createVNode(_component_el_form_item, null, {
                                default: _withId(() => [
                                  _createVNode(_component_el_input, {
                                    modelValue: _ctx.statistics_input,
                                    "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => (_ctx.statistics_input = $event)),
                                    placeholder: "搜索",
                                    "prefix-icon": "el-icon-search",
                                    size: "mini",
                                    style: {"width":"200px"}
                                  }, null, 8, ["modelValue"])
                                ]),
                                _: 1
                              }),
                              _createVNode(_component_el_form_item, null, {
                                default: _withId(() => [
                                  _createVNode(_component_el_button, {
                                    type: "primary",
                                    size: "mini",
                                    onClick: _cache[11] || (_cache[11] = ($event: any) => (_ctx.recordSearch('statistics_input')))
                                  }, {
                                    default: _withId(() => [
                                      _hoisted_9
                                    ]),
                                    _: 1
                                  })
                                ]),
                                _: 1
                              }),
                              _createVNode(_component_el_form_item, null, {
                                default: _withId(() => [
                                  _createVNode(_component_el_button, {
                                    type: "primary",
                                    size: "mini",
                                    onClick: _cache[12] || (_cache[12] = ($event: any) => (_ctx.clearSearch('statistics_input')))
                                  }, {
                                    default: _withId(() => [
                                      _hoisted_10
                                    ]),
                                    _: 1
                                  })
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          })
                        ]),
                        _withDirectives(_createVNode(_component_el_table, {
                          data: _ctx.getReportStat.results,
                          "header-cell-class-name": "tabelHeader"
                        }, {
                          default: _withId(() => [
                            _createVNode(_component_el_table_column, {
                              index: _ctx.indexMethod(0, 'statistics_input'),
                              type: "index",
                              label: "序号",
                              width: "80",
                              sortable: ""
                            }, null, 8, ["index"]),
                            _createVNode(_component_el_table_column, {
                              prop: "project_name",
                              label: "名称",
                              sortable: ""
                            }),
                            _createVNode(_component_el_table_column, {
                              prop: "report_auto",
                              label: "自动发送报告数",
                              sortable: ""
                            }),
                            _createVNode(_component_el_table_column, {
                              prop: "report_manual",
                              label: "手动发送报告数",
                              sortable: ""
                            }),
                            _createVNode(_component_el_table_column, {
                              prop: "update_time",
                              label: "最近发送时间",
                              sortable: ""
                            })
                          ]),
                          _: 1
                        }, 8, ["data"]), [
                          [_directive_loading, _ctx.loading]
                        ]),
                        _createVNode(_component_el_pagination, {
                          currentPage: _ctx.currentPage2,
                          "onUpdate:currentPage": _cache[13] || (_cache[13] = ($event: any) => (_ctx.currentPage2 = $event)),
                          "page-size": _ctx.statistics,
                          layout: "total, prev, pager, next,jumper",
                          total: _ctx.getReportStat.count,
                          onCurrentChange: _cache[14] || (_cache[14] = ($event: any) => (_ctx.handleCurrentChange('statistics_input')))
                        }, null, 8, ["currentPage", "page-size", "total"])
                      ]),
                      _: 1
                    })
                  ]),
                  _createVNode("div", _hoisted_11, [
                    _hoisted_12,
                    _createVNode(_component_el_divider),
                    _createVNode(_component_el_card, { class: "spacName2" }, {
                      default: _withId(() => [
                        _createVNode(_component_el_form, { inline: true }, {
                          default: _withId(() => [
                            _createVNode(_component_el_form_item, { label: "时间" }, {
                              default: _withId(() => [
                                _createVNode(_component_el_date_picker, {
                                  modelValue: _ctx.Timevalue,
                                  "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => (_ctx.Timevalue = $event)),
                                  type: "daterange",
                                  "start-placeholder": "Start date",
                                  "end-placeholder": "End date",
                                  "default-time": _ctx.defaultTime,
                                  size: "mini",
                                  "value-format": "YYYY-MM-DD"
                                }, null, 8, ["modelValue", "default-time"])
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_el_form_item, null, {
                              default: _withId(() => [
                                _createVNode(_component_el_button, {
                                  type: "primary",
                                  onClick: _cache[16] || (_cache[16] = ($event: any) => (_ctx.getTime())),
                                  size: "mini"
                                }, {
                                  default: _withId(() => [
                                    _hoisted_13
                                  ]),
                                  _: 1
                                })
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_el_form_item, null, {
                              default: _withId(() => [
                                _createVNode(_component_el_button, {
                                  type: "primary",
                                  onClick: _cache[17] || (_cache[17] = ($event: any) => (_ctx.getTime2())),
                                  size: "mini"
                                }, {
                                  default: _withId(() => [
                                    _hoisted_14
                                  ]),
                                  _: 1
                                })
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        }),
                        _withDirectives(_createVNode("div", _hoisted_15, null, 512), [
                          [_directive_loading, _ctx.loading]
                        ])
                      ]),
                      _: 1
                    })
                  ])
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
})